module.exports = __webpack_public_path__ + "static/media/creating_room.7727d540.mp4";